import { __assign, __rest } from "tslib";
// TierPromotionCardSemiDumb - accepts a PapiDeviation + CTA button type
// and turns it into primitive attributes of TierPromotionCardDumb
import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import SubscribeButton from '../../Button/SubscribeButton';
import EditTierButton from '../../Tier/EditTierButton';
import TierPromotionCardDumb from '../TierPromotionCardDumb';
import VerticalTierPromotionCardDumb from '../VerticalTierPromotionCardDumb';
import { getTierDescription } from '../_helpers';
import SubscribeVariant from '../../Button/SubscribeButton/variants/Subscribe';
import DummySubscribedVariant from '../../Button/SubscribeButton/variants/DummySubscribed';
import { useDeviationMatureFilter } from '../../utils/hooks/useDeviationMatureFilter';
import HiddenOverlay from '../HiddenOverlay';
import s from './TierPromotionCardSemiDumb.scss';
var TierPromotionCardSemiDumb = function (_a) {
    var deviation = _a.deviation, ctaButton = _a.ctaButton, ctaClassname = _a.ctaClassname, verticalLayout = _a.verticalLayout, props = __rest(_a, ["deviation", "ctaButton", "ctaClassname", "verticalLayout"]);
    var _b = useState(false), matureFilterOverridden = _b[0], setMatureFilterOverridden = _b[1];
    var _c = useDeviationMatureFilter(deviation), showBlocked = _c.showBlocked, overrideMatureFilter = _c.overrideMatureFilter;
    var onOverrideFilterClick = useCallback(function (e) {
        e.stopPropagation();
        overrideMatureFilter();
        setMatureFilterOverridden(true);
    }, [overrideMatureFilter]);
    if (!deviation.tier) {
        return null;
    }
    var _d = deviation.title, title = _d === void 0 ? '' : _d, author = deviation.author, tier = deviation.tier, coverImage = deviation.coverImage;
    // Note: subscribers stats are undefined when user chooses to hide them
    // therefore DO NOT DEFAULT COUNTS TO ZERO
    var _e = tier || {}, dollarPrice = _e.dollarPrice, _f = _e.stats, _g = _f === void 0 ? {} : _f, _h = _g.subscribers, numSubscribers = _h === void 0 ? undefined : _h, state = _e.state;
    var ctaButtonNode;
    switch (ctaButton) {
        case 'subscribe':
            ctaButtonNode = (React.createElement(SubscribeButton, { className: ctaClassname, type: 'subscribe', tier: deviation, matureFilterDisabled: true }));
            break;
        case 'view':
            ctaButtonNode = (React.createElement(SubscribeButton, { className: ctaClassname, type: 'view', tier: deviation, matureFilterDisabled: true }));
            break;
        case 'view-subscribed':
            ctaButtonNode = (React.createElement(DummySubscribedVariant, { className: ctaClassname, onClick: props.onClick }));
            break;
        case 'view-subscribe':
            ctaButtonNode = (React.createElement(SubscribeVariant, { className: ctaClassname, tier: deviation }));
            break;
        case 'edit':
            ctaButtonNode = (React.createElement(EditTierButton, { className: ctaClassname, tier: deviation }));
            break;
        case 'disabled':
            ctaButtonNode = (React.createElement(SubscribeButton, { className: ctaClassname, type: 'disabled', tier: deviation }));
            break;
        default:
    }
    var Card = verticalLayout
        ? VerticalTierPromotionCardDumb
        : TierPromotionCardDumb;
    var rootClasses = classnames(s['card-root'], verticalLayout && s['vertical']);
    return (React.createElement("div", { className: rootClasses },
        showBlocked && (React.createElement(HiddenOverlay, { className: s['card-overlay'], compact: true, showBackground: false, deviation: deviation, overrideMatureFilter: onOverrideFilterClick })),
        React.createElement(Card, __assign({ className: s['card'], author: author, coverImage: coverImage, showMatureCover: showBlocked || matureFilterOverridden, title: title, description: getTierDescription(deviation), numSubscribers: numSubscribers, price: dollarPrice, ctaButton: ctaButtonNode, state: state }, props))));
};
TierPromotionCardSemiDumb.displayName = 'TierPromotionCardSemiDumb';
export default TierPromotionCardSemiDumb;
//# sourceMappingURL=TierPromotionCardSemiDumb.js.map